import {useGraphql} from "@/core/graphql/service"

import {genqlBuilder} from "@/core/graphql/genql/builder"

import {QueryGenqlSelection, Query} from "../schema"

import {QueryOrderHistoryArgs} from "../schema"

export type QueryOrderHistoryVars = QueryOrderHistoryArgs

export type OrderHistoryResult = Query['order_history']

export function orderHistoryQuery(query: QueryGenqlSelection['order_history'] | null) {
      
    const build = (variables: QueryOrderHistoryVars) => genqlBuilder.build(query ? {order_history: query} : {__scalar: true}, {order_history: variables})
    const run = (variables: QueryOrderHistoryVars | null = null): Promise<OrderHistoryResult | null> => {
        const {queryWrapped} = useGraphql()
        return queryWrapped(build(variables || {}))
    }
                
    return {
      build,  
      run,
      _variables: {} as QueryOrderHistoryVars,
      _result: {} as OrderHistoryResult,
    }
}

export default orderHistoryQuery